import styled, { css } from 'styled-components'

import { BUTTON_CSS_VARIABLES } from './Button'

export const LoadingIndicatorDiv = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`

//* CSS Rules
export function setLoadingColorsStyles({ $loading }: { $loading: boolean }) {
  return (
    $loading &&
    css`
      &:disabled {
        ${BUTTON_CSS_VARIABLES.disabledBackgroundColor}: var(${BUTTON_CSS_VARIABLES.backgroundColor});
        ${BUTTON_CSS_VARIABLES.disabledBorderColor}: var(${BUTTON_CSS_VARIABLES.borderColor});
        ${BUTTON_CSS_VARIABLES.disabledColor}: var(${BUTTON_CSS_VARIABLES.color});
      }
    `
  )
}

export const AsyncButtonLoadingStyles = css<{ $loading: boolean }>`
  & > *:not(${LoadingIndicatorDiv}) {
    visibility: ${({ $loading }) => ($loading ? 'hidden' : 'visible')};
  }
`
